import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { searchContent } from '@plone/volto/actions'
import PropTypes from 'prop-types'
import { Image } from 'semantic-ui-react'
import 'remixicon/fonts/remixicon.css'
import Stack from '@mui/material/Stack'
import Grid from '@mui/material/Grid'

const getPeopleContent = (array = []) =>
    array.map((obj, item) => {
        obj[0] = item
        return obj
    }, {}
)


const IsotopeView = () => {
    const dispatch = useDispatch()
    const people = useSelector((state) =>
        getPeopleContent(state.search.subrequests.person?.items),
    )

    const content = useSelector((state) => state.workflow.transition)

    useEffect(() => {
        dispatch(
            searchContent(
                '/',
                {
                    portal_type: ['person'],
                    b_size: 1000,
                    fullobjects: true,
                },
                'person',
            ),
        );
    }, [dispatch, content])

    return (
        <Grid className="gridIsotope" container spacing={{ md: 8, sm: 8 }} rowSpacing={{ xs: 8 }}>
            {people.map((person) => (
                <Grid item className="grid-item" key={person.UID}>
                    <Image className="gridImg" src={person.img_field.scales.teaser.download} alt={person.img_field.filename} loading="lazy" />
                    <div className="gridContent">
                        <div className="stackWrapper">
                            <p className="gridContentName">{person.name_field}</p>

                            {person.position_field &&
                                <p className="gridContentPos">{ person.position_field }</p>
                            }

                            {person.description &&
                                <p>{ person.description }</p>
                            }

                            <div className="gridLinks">
                                {person.email_field &&
                                    <a href={`mailto:${ person.email_field }`}>{person.email_field}</a>
                                }
                                {person.phone_field &&
                                    <a href={`tel:${ person.phone_field }`}>{person.phone_field}</a>
                                }
                                {person.related_field &&
                                    <a href={person.related_field} download >vCard</a>
                                }
                            </div>
                        </div>
                    </div>
                </Grid>
            ))}
        </Grid>
    )
}

IsotopeView.propTypes = {
    data: PropTypes.objectOf(PropTypes.any),
}

export default IsotopeView